// extracted by mini-css-extract-plugin
export default {"button":"sIqKH","mobile":"_5MsvB","star":"zhyca","starFilled":"i2Y7P"};